import React from "react";

import * as styles from "./styles";
import SpinnerGIF from "~/components/deprecated/assets/spinner.gif";

export interface LoadingSpinnerProps {
  size?: "small" | "medium" | "large";
  image?: boolean;
  color?: "white" | "default";
  classes?: string;
}

export const LoadingSpinner = ({
  size = "medium",
  image,
  color = "default",
}: LoadingSpinnerProps) =>
  !image ? (
    <div
      className={styles.loadingSpinner}
      data-size={size}
      data-color={color}
    />
  ) : (
    <img
      src={SpinnerGIF}
      alt="Loading animation"
      width={90}
      height={90}
      className={styles.imageSpinner}
    />
  );
